import React from 'react';

const Login = () => {
  return (
    <div>
      <h2>Login Page</h2>
    </div>
  );
};

export default Login;
